import {
  LanguageId,
  useArticleTranslationRevertDraftMutation,
} from 'lib-knowledge-management-common/graphql';
import { ampli } from 'lib-shared-tracking';

type MutationFunction = ReturnType<
  typeof useArticleTranslationRevertDraftMutation
>[0];
type MutationReturnValue = ReturnType<MutationFunction>;

export type DiscardChangesFn = () => MutationReturnValue;

type UseDiscardChangesReturnValue = [
  DiscardChangesFn,
  ReturnType<typeof useArticleTranslationRevertDraftMutation>[1],
];

type UseDiscardChangesParams = { articleId: string; languageId: LanguageId };

function useDiscardChanges({
  articleId,
  languageId,
}: UseDiscardChangesParams): UseDiscardChangesReturnValue {
  const [discardFn, mutationResult] =
    useArticleTranslationRevertDraftMutation();
  const discard: DiscardChangesFn = async () => {
    const value = await discardFn({
      variables: {
        articleId,
        languageId,
      },
      refetchQueries: ['ArticleTranslation'],
    });

    ampli.knowledgeArticleChangesDiscarded({ articleId });

    return value;
  };

  return [discard, mutationResult];
}

export default useDiscardChanges;
